import { render, staticRenderFns } from "./AgentFeatures.vue?vue&type=template&id=dbf400a6&scoped=true"
import script from "./AgentFeatures.vue?vue&type=script&lang=js"
export * from "./AgentFeatures.vue?vue&type=script&lang=js"
import style0 from "./AgentFeatures.vue?vue&type=style&index=0&id=dbf400a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf400a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardActions,VCardText})
